import { useTranslation } from '@frontend/i18n';
import { StaticVerticalStepper } from '@frontend/static-vertical-stepper';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { Service } from '../../../types/tuuthfairy-types';
import { groupTuuthFairyServicesDataByDate } from '../../../utils/utils';
import { insuranceDetailsContainerStyles, insuranceDetailsOverflowStyles } from './styles';

type PayerDetailsProps = {
  service: Service[];
  isPrintReport?: boolean;
};

export const History = ({ service, isPrintReport = false }: PayerDetailsProps) => {
  const cssStyles = isPrintReport
    ? insuranceDetailsContainerStyles
    : [insuranceDetailsContainerStyles, insuranceDetailsOverflowStyles];
  const { t } = useTranslation('insuranceEligibilityReport');

  if (!service || !service.length) return null;

  const stepsData = groupTuuthFairyServicesDataByDate(service);

  return (
    <div css={cssStyles}>
      <Heading level={3} css={{ marginBottom: theme.spacing(1) }}>
        {t('History')}
      </Heading>
      <StaticVerticalStepper stepsInfo={stepsData} />
    </div>
  );
};
